module.exports = __webpack_public_path__ + "img/perks_MLBShop.a9802a78.jpg";